module.exports = __webpack_public_path__ + "mainassets/img/form2-cutting.f4fd3c58.svg";